import React from "react";
import { inject, observer } from "mobx-react";
import BroadcastStore from "./_stores/broadcast/BroadcastStore";
import BroadcastControl from "./broadcast-control";
import TailwindCard from "library/components/_tailwind/card";
import PrivateRequestCard from "./broadcast-preview/broadcast-private-request";
import TailwindFlex from "library/components/_tailwind/flex";
import LayoutStore from "library/core/stores/layout/LayoutStore";

type BroadcastSettingsTabProps = {
  broadcastStore?: BroadcastStore;
  layoutStore?: LayoutStore;
};

const BroadcastSettingsTab: React.ComponentType<BroadcastSettingsTabProps> = ({
  broadcastStore,
  layoutStore,
}) => {
  const { isPrivateConsentOpen } = broadcastStore!;
  const { screenOrientation } = layoutStore!;
  const isIpadLandscape =
    Boolean(LayoutStore.isAppleTablet()) &&
    screenOrientation === "landscape";

  return (
    <TailwindFlex
      flex={"flex-1"}
      height={isIpadLandscape ? "h-auto" : undefined}
      minHeight={isIpadLandscape ? "min-h-0" : undefined}
      overflow={isIpadLandscape ? "overflow-y-auto" : undefined}
      className={[
        "BroadcastSettingsTab",
        isPrivateConsentOpen ? "overflow-y-auto" : "",
      ]}
      flexDirection={"flex-col"}>
      {isPrivateConsentOpen && <PrivateRequestCard />}
      <TailwindCard
        height={isIpadLandscape ? "h-auto" : "h-full"}
        minHeight={isIpadLandscape ? "min-h-0" : undefined}
        width={"w-full"}
        backgroundColor={"bg-card-secondary-bg-color"}>
        <BroadcastControl />
      </TailwindCard>
    </TailwindFlex>
  );
};

export default inject(
  "broadcastStore",
  "layoutStore"
)(observer(BroadcastSettingsTab));
